import React from 'react';
import { FormControl } from 'react-bootstrap';

const UrlParams = (props) => {
	var paramItems = [];

	// we add 1 extra for user new input
	for (var i = 0; i <= props.params.length; i++) {
		paramItems.push(
			createParamItem(i, i < props.params.length ? props.params[i] : null, props.onParamChange)
		);
	}

	return (
		<div className="params-area">
			<label>Query Params</label>
			{paramItems}
		</div>
	);
}

const createParamItem = (index, param, onParamChange) => {
	return (
		<div className="param-item" key={index}>
			<FormControl 
				aria-describedby="basic-addon3" 
				placeholder="Key"
				value={param != null ? param.key : ''}
				onChange={(event) => onParamChange(index, event.target.value, true)} />
			<FormControl 
				aria-describedby="basic-addon3" 
				placeholder="Value"
				disabled={param==null}
				value={param != null && param.value != null ? param.value : ''}
				onChange={(event) => onParamChange(index, event.target.value, false)} />
		</div>
	);
}

export default UrlParams;